const backendUrl = "https://backend-xi-gules.vercel.app";
export default backendUrl;